import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { ThemeProvider } from "@powercore/ui"
import "@powercore/ui/styles.css"
import "./index.css"
import App from "./App"
import { AuthProvider } from "./platform"

// StrictMode temporarily disabled to debug infinite re-render loop
createRoot(document.getElementById('root')!).render(
  <ThemeProvider defaultTheme="mazo" defaultMode="light" storageKey="mazo-theme">
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </ThemeProvider>,
)
